var zhHans = {
  "commons.close": "关闭",
  "commons.company": "公司简介",
  "commons.expand": "扩展",
  "commons.internet": "因特网",
  "commons.learnMore": "了解更多",
  "commons.links": "链接",
  "commons.menu.label.compare": "型号比较",
  "commons.menu.label.compareAll": "比较全部",
  "commons.menu.label.explore": "探索",
  "commons.menu.label.new": "新品",
  "commons.menu.label.overview": "概览",
  "commons.social": "社交媒体",
  "commons.store": "商城",
  "commons.support": "技术支持",
  "commons.tools": "工具",
  "commons.training": "认证培训",
  "commons.viewAll": "查看全部",
  "commons.whatsNew": "新品介绍",
  "menu.action.label.calculateNow": "立即计算",
  "menu.description.cloudGateways": "高性能、可扩展的 IT 和弹性网络套件。",
  "menu.description.integrations": "创新的连接性和效率解决方案。",
  "menu.description.physicalSecurity": "可扩展的安全无缝 UniFi",
  "menu.description.startHere.caseStudies.celticDoyle": "了解Ubiquiti如何改变酒店的连接性，提升客人体验和运营效率。",
  "menu.description.startHere.caseStudies.fedexForum": "了解Ubiquiti如何帮助企业简化其IT基础设施，降低成本并提高生产力。",
  "menu.description.startHere.caseStudies.fiveGuys": "探索Ubiquiti如何帮助零售商优化其网络，提高客户满意度和店铺管理。",
  "menu.description.startHere.caseStudies.tinyDino": "了解Ubiquiti的强大解决方案如何在Industrial环境中提升连接性和效率。",
  "menu.description.startHere.caseStudies.unifiCaseStudies": "请查看我们的案例研究，了解UniFi的解决方案如何改变企业。",
  "menu.description.startHere.designCenter.nextAiCamera": "看看Ubiquiti解决方案如何提高教育机构的网络可靠性和性能，惠及学生和教职员工。",
  "menu.description.startHere.designCenter.nextAiCyber": "了解Ubiquiti如何改变酒店的连接性，提升客人体验和运营效率。",
  "menu.description.startHere.designCenter.sdWanSase": "了解Ubiquiti如何帮助企业简化其IT基础设施，降低成本并提高生产力。",
  "menu.description.startHere.designCenter.siteManager": "联邦快递论坛是一座顶级的多功能室内体育馆，是NBA孟菲斯灰熊队的主场。这座占地80万平方英尺的场馆可容纳18,000人，并且...",
  "menu.description.startHere.resources.blog": "探索网络和IT创新的最新动态。通过产品发布、专家见解和教程保持更新。",
  "menu.description.startHere.resources.enterpriseProgram": "了解Ubiquiti如何帮助企业简化其流程。",
  "menu.description.startHere.resources.eventsPrograms": "探索Ubiquiti如何帮助零售商优化其网络，提高客户满意度和店铺管理。",
  "menu.description.startHere.resources.techSpecs": "了解Ubiquiti如何改变酒店的连接性，提升客人体验和运营效率。",
  "menu.description.startHere.resources.training": "联邦快递论坛是一座顶级的多功能室内体育馆，是NBA孟菲斯灰熊队的主场。这座占地80万平方英尺的场馆可容纳18,000人，并且...",
  "menu.description.startHere.whyUniFi.howItWorks": "网络、物理安全等——所有这些都在一个直观的软件界面中UniFi，并具有可扩展的、无许可证的云管理。",
  "menu.description.startHere.whyUniFi.tcoCalculator": "网络、物理安全等——所有这些都在一个直观的软件界面中UniFi，并具有可扩展的、无许可证的云管理。",
  "menu.description.switching": "具备全功能切换的可扩展性。",
  "menu.description.wifi": "可扩展的WiFi 7，带来有线般的体验。",
  "menu.label.cloudGateways": "云网关主机",
  "menu.label.cloudGateways.compact": "紧凑型",
  "menu.label.cloudGateways.compact.description": "完全即插即用<br>无需CloudKey。",
  "menu.label.cloudGateways.enterpriseScale": "企业规模",
  "menu.label.cloudGateways.enterpriseScale.description": "管理500多个UniFi设备和5000多个客户端。",
  "menu.label.cloudGateways.identity": "Identity",
  "menu.label.cloudGateways.identity.description": "简化整个网络的用户访问。",
  "menu.label.cloudGateways.largeScale": "大规模",
  "menu.label.cloudGateways.largeScale.description": "专业级别，单一界面中的UniFi。",
  "menu.label.cloudGateways.overview": "Cloud Gateways 概述",
  "menu.label.cloudGateways.overview.description": "可扩展的IT和弹性网络套件。",
  "menu.label.cloudGateways.wifiIntegrated": "集成 WiFi",
  "menu.label.cloudGateways.wifiIntegrated.description": "完整的UniFi Network<br> 采用时尚设计。",
  "menu.label.cloudGateways.wifiIntegrated.dreamRouter": "Dream Router",
  "menu.label.cloudGateways.wifiIntegrated.dreamWall": "Dream Wall",
  "menu.label.cloudGateways.wifiIntegrated.express": "Express",
  "menu.label.introduction": "介绍",
  "menu.label.moreFromUi": "更多来自用户界面",
  "menu.label.newIntegrations": "集成",
  "menu.label.newIntegrations.accessoryTech": "配件技术",
  "menu.label.newIntegrations.accessoryTech.accessories": "配件",
  "menu.label.newIntegrations.accessoryTech.cables": "布线",
  "menu.label.newIntegrations.accessoryTech.description": "UniFi 部署<br> 必不可少",
  "menu.label.newIntegrations.accessoryTech.installations": "安装",
  "menu.label.newIntegrations.accessoryTech.rackDesigns": "机架设计",
  "menu.label.newIntegrations.accessoryTech.storage": "存储",
  "menu.label.newIntegrations.digitalSignage": "数字标识牌",
  "menu.label.newIntegrations.digitalSignage.description": "即插即用<br>数字标牌。",
  "menu.label.newIntegrations.evCharging": "电动车充电桩",
  "menu.label.newIntegrations.evCharging.description": "不仅仅是一个强大的<br>电动汽车充电器。",
  "menu.label.newIntegrations.hosting": "高级托管",
  "menu.label.newIntegrations.hosting.controlPlaneOptions": "可选控制平台",
  "menu.label.newIntegrations.hosting.description": "云密钥和独立网关。",
  "menu.label.newIntegrations.hosting.independentGateways": "独立网关",
  "menu.label.newIntegrations.internetSolutions": "互联网解决方案",
  "menu.label.newIntegrations.internetSolutions.cableInternet": "有线互联网",
  "menu.label.newIntegrations.internetSolutions.description": "无缝互联网和故障切换",
  "menu.label.newIntegrations.internetSolutions.lteBackup": "LTE Backup",
  "menu.label.newIntegrations.managedVoip": "托管VoIP",
  "menu.label.newIntegrations.managedVoip.description": "真正即插即用的<br>VoIP 解决方案。",
  "menu.label.newIntegrations.mobileRouting": "LTE/5G路由",
  "menu.label.newIntegrations.mobileRouting.description": "多合一<br>连接中心。",
  "menu.label.newIntegrations.overview": "新集成概述",
  "menu.label.newIntegrations.overview.description": "新集成概述",
  "menu.label.newIntegrations.premiumAudio": "高级音频",
  "menu.label.newIntegrations.premiumAudio.description": "强大的放大器，适合挑剔的音响发烧友。",
  "menu.label.newIntegrations.premiumIoT": "高级物联网",
  "menu.label.newIntegrations.premiumIoT.description": "通过连接的物联网解决方案赋能空间。",
  "menu.label.newIntegrations.professionalAV": "Professional A/V",
  "menu.label.newIntegrations.unifiDrive": "网络附加存储",
  "menu.label.newIntegrations.unifiDrive.description": "闪电般快速的私人存储。",
  "menu.label.physicalSecurity": "物理安全",
  "menu.label.physicalSecurity.bullet": "Bullet",
  "menu.label.physicalSecurity.domeTurret": "Dome & Turret",
  "menu.label.physicalSecurity.doorAccess": "门禁系统",
  "menu.label.physicalSecurity.overview": "物理安全概述",
  "menu.label.physicalSecurity.ptz": "PTZ",
  "menu.label.physicalSecurity.specialDevices": "特殊设备",
  "menu.label.physicalSecurity.videoRecorders": "视频录像机",
  "menu.label.security.bullet": "Bullet",
  "menu.label.security.bullet.description": "先进的光学技术，耐用且优雅的设计。",
  "menu.label.security.domeAndTurret": "Dome & Turret",
  "menu.label.security.domeAndTurret.description": "无忧安全，适用于大面积区域。",
  "menu.label.security.doorAccess": "门禁系统",
  "menu.label.security.doorAccess.description.1": "使用 UniFi Access 轻松管理",
  "menu.label.security.overview.description": "可扩展的安全性，<br>无缝的UniFi。",
  "menu.label.security.ptz": "PTZ",
  "menu.label.security.ptz.description": "实时控制，即使远程连接。",
  "menu.label.security.specialDevices": "特殊设备",
  "menu.label.security.specialDevices.aiEnhancements": "人工智能增强",
  "menu.label.security.specialDevices.compactCameras": "紧凑型摄像头",
  "menu.label.security.specialDevices.description": "物理安全<br>增强。",
  "menu.label.security.specialDevices.doorbells": "门铃",
  "menu.label.security.specialDevices.floodlight": "泛光灯",
  "menu.label.security.specialDevices.superLink": "SuperLink",
  "menu.label.security.videoRecorders": "NeXT代NVR",
  "menu.label.security.videoRecorders.description": "闪电般快速的私人存储。",
  "menu.label.siteManager": "站点管理员",
  "menu.label.startHere": "从这里开始",
  "menu.label.startHere.accessoryTech": "配件技术",
  "menu.label.startHere.accessoryTech.cables": "布线",
  "menu.label.startHere.accessoryTech.installations": "安装",
  "menu.label.startHere.accessoryTech.powerTech": "电源技术",
  "menu.label.startHere.accessoryTech.rackDesigns": "机架设计",
  "menu.label.startHere.accessoryTech.storage": "存储硬盘",
  "menu.label.startHere.caseStudies": "案例研究",
  "menu.label.startHere.caseStudies.featured.celticDoyle": "凯尔特人 & 多伊尔收藏酒店",
  "menu.label.startHere.caseStudies.featured.fedexForum": "联邦快递论坛：18,000座的体育馆",
  "menu.label.startHere.caseStudies.featured.fiveGuys": "Five Guys：250多家餐厅开业！",
  "menu.label.startHere.caseStudies.featured.tinyDino": "小恐龙代理公司",
  "menu.label.startHere.caseStudies.unifiCaseStudies": "UniFi案例研究",
  "menu.label.startHere.designCenter": "设计中心",
  "menu.label.startHere.designCenter.description": "看看Ubiquiti解决方案如何提高教育机构的网络可靠性和性能，惠及学生和教职员工。",
  "menu.label.startHere.designCenter.nextAiCamera": "NextAI相机",
  "menu.label.startHere.designCenter.nextAiCyber": "NextAI网络",
  "menu.label.startHere.designCenter.sdWanSase": "SD-WAN/SASE",
  "menu.label.startHere.designCenter.siteManager": "站点管理员",
  "menu.label.startHere.enterpriseProgram.downloads": "企业优势",
  "menu.label.startHere.knowledgeCenter": "知识中心",
  "menu.label.startHere.knowledgeCenter.largeProjectAssistance": "大型项目支持",
  "menu.label.startHere.knowledgeCenter.professionalSupport": "专家支持",
  "menu.label.startHere.knowledgeCenter.uispCarrierPlatform": "UISP 运营商平台",
  "menu.label.startHere.partnerHub": "与UniFi合作",
  "menu.label.startHere.resources": "资源",
  "menu.label.startHere.resources.blog": "博客",
  "menu.label.startHere.resources.eventsPrograms": "活动与项目",
  "menu.label.startHere.resources.proSupport": "专家支持",
  "menu.label.startHere.resources.techSpecs": "技术规格",
  "menu.label.startHere.resources.training": "认证培训",
  "menu.label.startHere.siteMap": "网站地图",
  "menu.label.startHere.whyUniFi": "如何运行？",
  "menu.label.startHere.whyUniFi.designCenter": "设计中心",
  "menu.label.startHere.whyUniFi.howItWorks": "如何运行",
  "menu.label.startHere.whyUniFi.howItWorks.large": "大",
  "menu.label.startHere.whyUniFi.howItWorks.massiveScale": "大规模",
  "menu.label.startHere.whyUniFi.howItWorks.multiSite": "多站点",
  "menu.label.startHere.whyUniFi.howItWorks.simple": "简单",
  "menu.label.startHere.whyUniFi.migrationAssistance": "迁移协助",
  "menu.label.startHere.whyUniFi.migrationAssistant": "迁移助理",
  "menu.label.storybook.first": "第一项",
  "menu.label.storybook.second": "第二项",
  "menu.label.storybook.third": "第三项",
  "menu.label.switching": "交换机",
  "menu.label.switching.aggregation": "Aggregation",
  "menu.label.switching.aggregation.description": "高容量<br>交换。",
  "menu.label.switching.compact": "紧凑型",
  "menu.label.switching.compact.description": "多千兆以太网 & 多功能",
  "menu.label.switching.coreAggregation": "核心与Aggregation",
  "menu.label.switching.edge": "边缘",
  "menu.label.switching.enterprise": "Enterprise",
  "menu.label.switching.enterprise.description": "10 GbE &<br> 以上",
  "menu.label.switching.gbe.1u": "GbE 1U",
  "menu.label.switching.gbe.1u.10": "2.5/10 GbE 1U",
  "menu.label.switching.gbe.1u.10.description": "2.5/10 GbE 和 <br> Etherlighting™.",
  "menu.label.switching.gbe.1u.description": "终极价值。",
  "menu.label.switching.overview": "概览",
  "menu.label.switching.overview.description": "可扩展，具备全功能切换。",
  "menu.label.switching.professional": "Professional",
  "menu.label.switching.professional.description": "2.5/10 GbE & <br> Etherlighting™",
  "menu.label.switching.value": "价值",
  "menu.label.switching.value.description": "千兆以太网，无风扇 & 静音散热",
  "menu.label.switching.wan": "WAN",
  "menu.label.switching.wan.description": "设计用于高可用性",
  "menu.label.unifi": "UniFi",
  "menu.label.viewSiteMapTopology": "网站地图和拓扑结构",
  "menu.label.wifi": "WiFi",
  "menu.label.wifi.bridging": "桥接",
  "menu.label.wifi.bridging.buildingBridge": "Building Bridging",
  "menu.label.wifi.bridging.description": "像电线一样连接建筑物，但没有电线。",
  "menu.label.wifi.bridging.deviceBridge": "Device Bridge",
  "menu.label.wifi.buildingBridge": "桥接",
  "menu.label.wifi.enterprise": "Enterprise",
  "menu.label.wifi.enterprise.description": "全新UniFi Enterprise<br> WiFi 7系列",
  "menu.label.wifi.flagship": "旗舰式",
  "menu.label.wifi.flagship.description": "吸顶式安装以实现最佳性能。",
  "menu.label.wifi.megaCapacity": "超大容量",
  "menu.label.wifi.megaCapacity.description": "为数千名客户提供服务。",
  "menu.label.wifi.outdoor": "室外",
  "menu.label.wifi.outdoor.description": "灵活部署到任何环境。",
  "menu.label.wifi.overview": "概览",
  "menu.label.wifi.overview.description": "可扩展的WiFi 7，带来有线般的体验。",
  "menu.label.wifi.wall": "壁挂",
  "menu.label.wifi.wall.description": "墙壁式实现<br>无缝安装。",
  "menu.old.cloudGateways": "云网关主机",
  "menu.siteMap.closeSiteMap": "关闭所有站点地图",
  "menu.siteMap.title": "UniFi 产品网站地图",
  "menu.topology.title": "视觉拓扑"
};
export { zhHans as default };
//# sourceMappingURL=zh-Hans.json.mjs.map
